// src/reducers/authReducer.js
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL, REGISTER_SUCCESS, REGISTER_FAIL, LOGOUT } from '../actions/types';

const initialState = {
  isAuthenticated: !!localStorage.getItem('auth'),
  user: localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : null,
  loading: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        loading: false,
        error: null,
      };
      case LOGIN_FAIL:
        return {
          ...state,
          isAuthenticated: false,
          user: null,
          loading: false,
          error: action.payload,
        };
    case REGISTER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

export default authReducer;
